import {defaultPagination} from "@/services/pagination";
import {
  listRecipients,
  deleteRecipient,
  editRecipient,
  addRecipient,
  updateNotificationSettings,
  getNotificationSettingsStatus,
} from "@/services/api/app/common/settings";

const defaultState = () => ({
  recipients: [],
  pagination: {
    ...defaultPagination(),
    sortDescending: false,
  },
  isEnabledNotification: false,
});

export default {
  namespaced: true,
  actions: {
    listRecipients({commit, state}) {
      return listRecipients({
        pagination: state.pagination,
        providerTenantType: 5,
      })
        .then(({result, pagination}) => {
          commit('setRecipients', result)
          commit('setPagination', pagination)
        })
    },
    deleteRecipient({commit, state}, {id}) {
      return deleteRecipient(id)
    },
    editRecipient({commit, state}, data) {
      return editRecipient(data)
    },
    addRecipient({commit, state}, data) {
      data = {
        ...data,
        providerTenantType: 5
      };
      return addRecipient(data)
    },
    updateNotificationSettings({commit, state}, data) {
      data = {
        ...data,
        providerTenantType: 5
      };

      return updateNotificationSettings(data)
    },
    getNotificationSettingsStatus({commit}) {
      return getNotificationSettingsStatus(5)
        .then(notificationStatus => {
          commit('setNotificationStatus', notificationStatus);
          return notificationStatus;
        })
    },
  },

  mutations: {
    setRecipients(state, recipients) {
      state.recipients = recipients;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setNotificationStatus(state, isEnabledNotification) {
      state.isEnabledNotification = isEnabledNotification;
    },

    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortDescending: false,
      }
    },

    resetState(state) {
      Object.assign(state, defaultState())
    }
  },

  state: defaultState,
}
